// extracted by mini-css-extract-plugin
export default {"tableWrapperContainer":"startDateChanges_tableWrapperContainer__y7tUo","title":"startDateChanges_title__50cyU","selectWrapper":"startDateChanges_selectWrapper__E9JN8"};